import { create } from "zustand"

interface State {
  currentTokenId: number
}

interface Actions {
  setCurrentTokenId: (currentTokenId: State["currentTokenId"]) => void
}

export const useCatalog = create<State & Actions>((set) => ({
  currentTokenId: -2,
  setCurrentTokenId: (currentTokenId) => set(() => ({ currentTokenId })),
}))
